import React from 'react'
// themes
import { colors } from 'themes'
// views
import { HoverablePopover } from './views'
import { PopoverPosition, PopoverProps } from '@mui/material/Popover'
// utils
import { transparentize } from 'polished'

const transformOrigin = {
  horizontal: 'left',
  vertical: 'top'
}

const PAPER_PROPS = {
  style: {
    color: colors.blue500,
    background: transparentize(0.03, colors.white100),
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center'
  }
}

interface Props extends Omit<PopoverProps, 'open'> {
  trigger: React.ReactElement<{ onMouseEnter?: (event: React.MouseEvent) => void }>
}

const VerticalMenu: React.FC<Props> = ({ trigger, children, ...props }) => {
  const [position, setPosition] = React.useState<PopoverPosition>()

  const handleMouseEnter = (event: React.MouseEvent) => {
    if (trigger.props.onMouseEnter) {
      trigger.props.onMouseEnter(event)
    }

    setPosition({ left: event.clientX, top: event.clientY })
  }

  return (
    <HoverablePopover
      anchorEl={null}
      trigger={trigger}
      PaperProps={PAPER_PROPS}
      anchorPosition={position}
      transformOrigin={transformOrigin}
      anchorReference={'anchorPosition'}
      triggerMouseEnter={handleMouseEnter}
      {...props}>
      <>{children}</>
    </HoverablePopover>
  )
}

export default VerticalMenu
